var header_styles = {
  container: {
    display: "flex",
    padding: "0px",
    alignItems: "center",
    gap: "16px",
    alignSelf: "stretch",
    background: "#818589",
    color: "white",
  },
  header_title: {
    flex: "1 0 0" as const,
    color: "var(--White, #FFF)",
    textAlign: "center" as const,
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
  },
};

export default header_styles;
